module.exports = __webpack_public_path__ + "img/evaluator.a514ef20.svg";